import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IReport {
    Checked?: boolean
    CreatedAt: number
    extra?: string
    id: string
    made_by: {
        id: string
        name?: string
        thumbnail?: string
    }
    parent_type?: string
    parent_id?: string
}

export const getReport = async (size: number, current_page: number = 1): Promise<ApiRes<IReport[]>> => {
    return await apiGet(API_URL, `admin/reports?page_size=${size}&current_page=${current_page}`)
}
